import * as Pedometer from './Pedometer';
export { default as Accelerometer } from './Accelerometer';
export { default as Barometer } from './Barometer';
export { default as DeviceMotion, DeviceMotionOrientation, } from './DeviceMotion';
export { default as DeviceSensor } from './DeviceSensor';
export { default as Gyroscope } from './Gyroscope';
export { default as Magnetometer } from './Magnetometer';
export { default as MagnetometerUncalibrated, } from './MagnetometerUncalibrated';
export { default as LightSensor } from './LightSensor';
export { Pedometer };
//# sourceMappingURL=index.js.map